export default __webpack_public_path__ + "static/media/Settings_Mobile.2fb0920e.svg";